/*
 * HomePage
 *
 * This is the first thing users see of our App, at the '/' route
 *
 */

import React from 'react';
import { Footer } from '../../features/footer/Footer';
import { Header } from '../../features/header/Header';
import { Container, Row, Col } from 'reactstrap';
import { withAuthentication } from '../../common/authentication';

import styled from 'styled-components';
import heroLogo from '../../images/parameta.svg';

const Hero = styled.div`
  position: relative;
`;

/* teal-color: rgb(0, 255, 255);
$brand-blue-color: 
$brand-mid-blue-color: rgb(4, 95, 176);
$brand-dark-blue-color: rgb(0, 0, 96) */

const HeroBody = styled.div`
  padding: 90px 0px;
  background: linear-gradient(
    45deg,
    rgba(255, 150, 80, 0.7) 0%,
    /* Soft orange (bottom left) */ rgba(255, 200, 160, 0.7) 25%,
    /* Light peach */ rgba(255, 240, 200, 0.7) 50%,
    /* Soft cream */ rgba(180, 240, 220, 0.7) 75%,
    /* Light teal */ rgba(120, 180, 240, 0.7) 90%,
    /* Light blue */ rgba(90, 130, 220, 0.7) 100% /* Deeper blue (top right) */
  );
  color: rgba(0, 0, 0, 0.87);
`;

const HeroH1 = styled.h1`
  margin-top: 0;
  font-size: 42px;
`;

const HeroH1Strong = styled.h1`
  margin-top: 0;
  font-size: 72px;
`;

const HeroH2 = styled.h2`
  margin-top: 0;
  font-size: 22px;
`;

const TPIcapEndorsement = styled.div`
  padding: 1rem;
  background: white;
`;

const Description = styled.div`
  margin-top: 1rem;
`;

const HeroContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 4.5rem; /* 72px */
  padding-top: 0.75rem;
  padding-left: 1.5rem; /* 24px */
  padding-right: 1.75rem; /* 28px */
  background-color: rgb(238, 244, 255);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
`;

const LogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 3.5rem; /* 56px, increased for larger logo */
`;

const LogoImage = styled.img`
  opacity: 1;
  transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1);
  height: 3.5rem; /* 56px, increased for larger logo */
  margin-right: 0.5rem;
`;

const LogoTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 3.5rem; /* Match logo height for vertical alignment */
`;

const ParametaText = styled.span`
  font-family: 'Manrope', sans-serif;
  font-size: 1.75rem; /* 28px, increased */
  font-weight: 700;
  color: #0a1a2f;
  letter-spacing: 0.5px;
  line-height: 1.1;
`;

const SolutionsText = styled.span`
  font-family: 'Manrope', sans-serif;
  font-size: 1.75rem; /* 28px, increased */
  font-weight: 300;
  color: #0a1a2f;
  letter-spacing: 0.5px;
  line-height: 1.1;
  margin-top: 0.1rem;
`;

function HomePage(props) {
  return (
    <>
      <Header />
      <HeroContainer>
        <LogoContainer>
          <LogoImage src={heroLogo} alt="parameta logo" />
          <LogoTextContainer>
            <ParametaText>Parameta</ParametaText>
            <SolutionsText>Solutions</SolutionsText>
          </LogoTextContainer>
        </LogoContainer>
      </HeroContainer>
      <Hero>
        <HeroBody>
          <Container>
            <Row>
              <Col md="8">
                <HeroH1>REDEFINING DATA SOLUTIONS</HeroH1>
                <HeroH1Strong>CREATING POSSIBILITY</HeroH1Strong>
                <HeroH2>
                  Put precision in every decision with your PARAMETA Solutions
                  Transaction Cost Analysis platform.
                </HeroH2>
              </Col>
              <Col />
            </Row>
          </Container>
        </HeroBody>
        <TPIcapEndorsement>
          <Container>
            <Row>
              <Col md="8">
                <Description>
                  PARAMETA Solution's Transaction Cost Analysis (TCA) is an
                  independent third party solution that leverages TP ICAP
                  Group's trade and quote data. This information is aggregated
                  with other publicly available data to create a bespoke
                  analysis on OTC trading. The results of our analysis has a
                  range of use cases from monitoring, measuring, and documenting
                  the costs associated with trading to improving the investment
                  workflow and assisting in pre-trade decision making.
                </Description>
              </Col>
              <Col />
            </Row>
          </Container>
        </TPIcapEndorsement>
      </Hero>
      <Footer shape={false} />
    </>
  );
}

export default withAuthentication(HomePage);
